import React, { useContext } from "react";

import { Dropdown } from "semantic-ui-react";

import fileDownload from "js-file-download";
import { parse } from "json2csv";

import Alerts from "utilities/Alerts";
import { parseDate } from "utilities/date";

import { reportContext } from "contexts/ReportContext";

function DownloadDropdownMenuItem() {
	const reportData = useContext(reportContext);

	const downloadableData = () =>
		reportData?.filteredReportList.map((item) => ({
			invoice: item.invoiceNo,
			...(reportData?.type === "purchase" ||
			reportData?.type === "purchasereturn"
				? { supplier: item.supplier.name }
				: { buyer: item.buyer }),
			date: parseDate(item.date, "/", true),
			quantity: item.quantity,
			rate: item.rate,
			amount: parseFloat(item.quantity) * parseFloat(item.rate),
			paid: item.state,
		}));

	const getFileNameAndDates = (reportData, ext = ".txt") => {
		const dateNow = parseDate(Date.now(), "/", true);
		const [startDate, endDate] = reportData.captureDate.map((dt) =>
			parseDate(dt, "/", true)
		);

		const fName = `${reportData?.type}-(${dateNow})-(${startDate}_to_${endDate})${ext}`;

		return { fileName: fName, dateNow, startDate, endDate };
	};

	const downloadAsJSON = async () => {
		try {
			if (!reportData?.captureDate)
				throw new Error("Date not specified.");

			const { dateNow, fileName } = getFileNameAndDates(
				reportData,
				".json"
			);

			const dData = downloadableData();
			fileDownload(
				JSON.stringify({ reportGeneratedOn: dateNow, data: dData }),
				fileName + ".json",
				"application/json"
			);
		} catch (ex) {
			Alerts.error("Sorry, could not download.", ex.message);
		}
	};
	const downloadAsCSV = async () => {
		try {
			if (!reportData.captureDate) throw new Error("Date not specified.");

			const { fileName, dateNow } = getFileNameAndDates(
				reportData,
				".csv"
			);

			const dData = downloadableData();
			const opts = Object.keys(dData[0]);

			const csvData = `generatedOn\r${dateNow}\r\r${parse(dData, opts)}`;

			fileDownload(csvData, fileName, "application/text");
		} catch (ex) {
			Alerts.error("Sorry, could not download.", ex.message);
		}
	};

	return (
		<Dropdown
			disabled={!reportData?.filteredReportList.length}
			icon="download"
			floating
		>
			<Dropdown.Menu>
				<Dropdown.Header>Download as</Dropdown.Header>
				<Dropdown.Divider />
				<Dropdown.Item onClick={downloadAsJSON}>
					JSON File
				</Dropdown.Item>
				<Dropdown.Item onClick={downloadAsCSV}>CSV File</Dropdown.Item>
			</Dropdown.Menu>
		</Dropdown>
	);
}

export default DownloadDropdownMenuItem;
